import { useMemo } from 'react';

export function useMemoWithDeps(factory, defaultValue, deps) {
  return useMemo(() => {
    if (deps.some(x => x === null || x === undefined)) return defaultValue;

    return factory(...deps);
  }, deps);
}
